import {useSelector} from 'react-redux';
import {Navigate, Outlet, useLocation} from 'react-router-dom';
import {selectHasCheckedAuth, selectIsAuthenticated} from '@/store/features/authSlice';
import {Loader2} from 'lucide-react';

const ProtectedRoute = () => {
    const location = useLocation();

    const isAuthenticated = useSelector(selectIsAuthenticated);
    const hasCheckedAuth = useSelector(selectHasCheckedAuth);
    const {token} = useSelector(state => state.auth);

    // ⏳ Attente du syncAuthState initial
    if (!hasCheckedAuth) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <Loader2 className="h-10 w-10 animate-spin text-blue-600" />
            </div>
        );
    }

    // ❌ Pas authentifié → login
    if (!isAuthenticated) {
        return (
            <Navigate
                to="/login"
                state={{ from: location }}
                replace
            />
        );
    }

    // ✅ OK
    return <Outlet />;
};

export default ProtectedRoute;
